import "@fontsource-variable/nunito-sans/index.css";
import "./index.css";
import "./i18n";

import { RouterProvider } from "react-router";
import { ToastContainer } from "react-toastify";
import router from "./router";
import { AuthProvider } from "./context/auth";
import { LanguageProvider } from "./context/language";
import { ThemeProvider } from "./context/theme";
import ReactDOM from "react-dom/client";
import { config, posthogKey } from "./config/posthog";
import CookieBanner from "./molecules/CookieBanner";
import { PostHogProvider } from "posthog-js/react";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <div className="bg-background flex min-h-screen flex-col">
    <PostHogProvider apiKey={posthogKey} options={config}>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <RouterProvider router={router} />
            <CookieBanner />
            <ToastContainer
              hideProgressBar={true}
              position="bottom-right"
              stacked
            />
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </PostHogProvider>
  </div>,
);
